/* eslint-disable no-console */
import { useState, useEffect } from "react";
import { CarteleriaList, Header } from "../../components";
import { useAuthContext } from "../../context/auth";
import { useCurrency } from "../../utils";
import { resumenCarteleria } from "../../utils/carteleria/presentacionCarteleria";
import { client } from "../../utils/supabase";
import "./stylesCarteleriaPage.scss";

const CarteleriaPage = () => {
  const [showFormModal, setShowFormModal] = useState(false);
  const [negocios, setNegocios] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(true);

  const { pais } = useAuthContext();
  const normalizedPais = pais ? pais.charAt(0).toUpperCase() + pais.slice(1).toLowerCase() : "";
  const { loadingRates, convert, formatAmount } = useCurrency();
  const monedaLocal = normalizedPais === "Chile" ? "CLP" : "PEN";

  useEffect(() => {
    if (!normalizedPais) return;
    const fetchSummary = async () => {
      setLoadingSummary(true);
      try {
        const { data, error } = await client
          .from("negocios_carteleria")
          .select("*")
          .eq("pais", normalizedPais)
          .eq("eliminada", false);
        if (error) throw error;
        setNegocios(data || []);
      } catch (err) {
        console.error("Error fetching summary:", err);
      } finally {
        setLoadingSummary(false);
      }
    };
    fetchSummary();
  }, [normalizedPais]);

  // Resumen: todo sale del motor `calendarioNegocio` + el helper único de conversión (F3a). Solo `Activo`
  // cuenta para la facturación mensual estimada (D10 / regla 10.113: un 100 % es vendido, no instalado).
  const { activos, pipeline, totalPantallas, activosOPEX, activosCAPEX, facturacionMensual } = loadingRates
    ? { activos: 0, pipeline: 0, totalPantallas: 0, activosOPEX: 0, activosCAPEX: 0, facturacionMensual: 0 }
    : resumenCarteleria(negocios, { convertir: convert, monedaLocal, hoy: new Date() });

  const labelStyle = { minWidth: "160px" };
  const sep = <span style={{ margin: "0 0.4rem", color: "#999" }}>|</span>;

  const summaryContent =
    loadingSummary || loadingRates ? null : (
      <div className="d-flex align-items-start" style={{ gap: ".69rem", fontSize: "16.5px" }}>
        <div className="text-start" style={labelStyle}>
          <div>
            <strong>Negocios</strong>
          </div>
          <div>
            <strong>Fact. Mensual Est.</strong>
          </div>
        </div>
        <div className="text-start" style={{ fontSize: "16.5px" }}>
          <div>
            {sep} Activos: <strong>{activos}</strong>
            {sep} Pipeline: <strong>{pipeline}</strong>
            {sep} Pantallas: <strong>{totalPantallas}</strong>
          </div>
          <div>
            {sep} {formatAmount(facturacionMensual, monedaLocal)}
            {sep} OPEX: <strong>{activosOPEX}</strong>
            {sep} CAPEX: <strong>{activosCAPEX}</strong>
          </div>
        </div>
      </div>
    );

  return (
    <div className="carteleria-page">
      <Header leftContent={summaryContent}>
        <button className="btn btn-primary" onClick={() => setShowFormModal(true)}>
          Nuevo Proyecto
        </button>
      </Header>
      <div className="carteleria-list-full">
        <CarteleriaList showFormModal={showFormModal} setShowFormModal={setShowFormModal} />
      </div>
    </div>
  );
};

export default CarteleriaPage;
